(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 54493:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(96132);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 56951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11101);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83974);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23158);








function BuilderHead(props) {
    var isRateParityWebAppPage = props.hasOwnProperty("isRateParityWebAppPage") ? props.isRateParityWebAppPage : false;
    var manifestPath = "/manifest.json";
    if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].booleanState */ .Z.booleanState(props.property)) {
        manifestPath = "../../" + manifestPath.split("/")[1];
    }
    var showRateParityWidget = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_general_show_rateparity_widget") == 1 ? true : false;
    });
    var seoRobotsInstructions = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_search_engine_instuctions");
    });
    var showCookieYes = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_enable") == 1 ? true : false;
    });
    var cookiesYesIdentifier = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_identifier");
    });
    var cookiesYesScript = function() {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(cookiesYesIdentifier)) {
            return "https://cdn-cookieyes.com/client_data/" + cookiesYesIdentifier + "/script.js";
        }
        return null;
    };
    var rateParityHasLoaded = function() {
        if (true) {
            return document.getElementById("rp-allinone");
        }
        return true;
    };
    var cookieYesHasLoaded = function() {
        if (true) {
            return document.getElementsByClassName("cky-preference-center").length > 0;
        }
        return true;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.font != null) {
            var head = document.getElementsByTagName("head")[0];
            var style = document.createElement("style");
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            switch(props.font){
                case "Roboto Slab":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Serif":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Roboto":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', sans-serif !important}";
                    break;
                case "Vollkorn":
                    link.href = "https://fonts.googleapis.com/css?family=Vollkorn:400,600,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Vollkorn', serif !important}";
                    break;
                case "Noto Sans":
                    link.href = "https://fonts.googleapis.com/css?family=Noto+Sans:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Noto Sans', sans-serif !important}";
                    break;
                case "Cousine":
                    link.href = "https://fonts.googleapis.com/css?family=Cousine:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', monospace !important}";
                    break;
                case "Playfair":
                    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Playfair Display', serif !important}";
                    break;
                default:
                    link.href = "https://fonts.googleapis.com/icon?family=Material+Icons&display=swap";
                    break;
            }
            head.appendChild(link);
            head.appendChild(style);
        }
    });
    var googleSchema = {
        "@context": "https://schema.org/",
        "@type": "Organization",
        "name": "".concat(props.googleSchemaTitle),
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "".concat(props.googleSchemaStreetAddress),
            "addressLocality": "".concat(props.googleSchemaCity),
            "addressRegion": "".concat(props.googleSchemaCountry),
            "postalCode": "".concat(props.googleSchemaZip)
        },
        "telephone": "".concat(props.googleSchemaPhone)
    };
    var absoluteUrl = function(url) {
        if (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(url)) return null;
        if (/^https?:\/\//i.test(url)) return url;
        var isLocal = /(^|\.)(localhost|local)(:\d+)?(\/|$)/i.test(url);
        return (isLocal ? "http://" : "https://") + url.replace(/^\/+/, "");
    };
    var canonicalUrl = absoluteUrl(props.seoUrl);
    var pageUrl = canonicalUrl || props.domain;
    var pageSchema = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.image_fb_meta) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        "@context": "https://schema.org/",
        "@type": "WebPage",
        "name": props.title
    }, pageUrl ? {
        "url": pageUrl
    } : {}), {
        "primaryImageOfPage": {
            "@type": "ImageObject",
            "url": props.image_fb_meta
        },
        "image": props.image_fb_meta
    }) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }),
            props.keywords != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: props.titleOfficial
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(seoRobotsInstructions) ? seoRobotsInstructions : "index, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: props.designColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "referrer",
                content: "strict-origin"
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            props.icon_60 != null && props.icon_60 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    })
                ]
            }),
            props.icon_76 != null && props.icon_76 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "76x76",
                href: props.icon_76
            }),
            props.icon_120 != null && props.icon_120 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: props.icon_120
            }),
            props.icon_152 != null && props.icon_152 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: props.icon_152
            }),
            props.icon_256 != null && props.icon_256 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    })
                ]
            }),
            props.icon != null && props.icon != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: props.icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-touch-fullscreen",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:type",
                content: "place"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.desc_fb_meta) ? props.desc_fb_meta : props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.image_fb_meta
            }),
            props.image_fb_meta_width != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: String(props.image_fb_meta_width)
            }),
            props.image_fb_meta_height != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: String(props.image_fb_meta_height)
            }),
            props.lat_fb_meta != null && props.lat_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:latitude",
                content: props.lat_fb_meta
            }) : null,
            props.lon_fb_meta != null && props.lon_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:longitude",
                content: props.lon_fb_meta
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: props.site_name_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:alt",
                content: props.twitter_img_alt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(googleSchema)
                }
            }),
            pageSchema && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(pageSchema)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: manifestPath
            }),
            !cookieYesHasLoaded() && showCookieYes && cookiesYesScript != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                id: "cookieyes",
                type: "text/javascript",
                src: cookiesYesScript(),
                defer: true
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            !rateParityHasLoaded() && !isRateParityWebAppPage && showRateParityWidget ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "text/javascript",
                    src: "https://code.rateparity.com/versions/installer.min.js",
                    defer: true
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BuilderHead);


/***/ }),

/***/ 96132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95925);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18256);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1860);
/* harmony import */ var _components_head_BuilderHead__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56951);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83974);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66638);










var IndexSections = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3098), __webpack_require__.e(8567), __webpack_require__.e(2817), __webpack_require__.e(5175), __webpack_require__.e(1370), __webpack_require__.e(4795), __webpack_require__.e(2368), __webpack_require__.e(3955), __webpack_require__.e(1100), __webpack_require__.e(1372), __webpack_require__.e(6171), __webpack_require__.e(4906), __webpack_require__.e(5885), __webpack_require__.e(8157), __webpack_require__.e(8630), __webpack_require__.e(5992), __webpack_require__.e(2511), __webpack_require__.e(6420), __webpack_require__.e(2331)]).then(__webpack_require__.bind(__webpack_require__, 11311));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11311)
            ];
        }
    },
    suspense: true
});
var Addons = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 8545).then(__webpack_require__.bind(__webpack_require__, 88545));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88545)
            ];
        }
    }
});
var Scripts = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var __N_SSP = true;
function Home(props) {
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useT */ .NT)();
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* .page */ .M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.isMobile = props.isMobile;
    pageContext.isTablet = props.isTablet;
    pageContext.isDesktop = props.isDesktop;
    pageContext.appSettings = props.app;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (window !== undefined) {
            setUrlHref(window.location.href);
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app = props.app;
    var builder = app.builder;
    var head = props.head;
    var footer = props.footer;
    var app_data = props.app_data;
    var locations = props.locations;
    var navigation = props.navigation;
    var content = props.content;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var html_sections = props.html_sections;
    var script_sections = props.script_sections;
    var distincts = props.distincts;
    var profile = props.profile;
    var destinations = props.destinations;
    var collections = props.collections;
    var isDesktop = props.isDesktop;
    var image_fb_meta = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_6__/* ["default"].isValidArray */ .Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head_BuilderHead__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: head.data.title + " - " + head.data.motto + " | " + t("common.home"),
                keywords: head.data.meta_keywords,
                titleOfficial: head.data.titleOfficial,
                domain: urlHref,
                icon_60: head.data.icon_60,
                seoUrl: head.data.urlSlug ? props.domain + "/" + head.data.urlSlug : null,
                icon_76: head.data.icon_76,
                icon_120: head.data.icon_120,
                icon_152: head.data.icon_152,
                icon_256: head.data.icon_256,
                icon: head.data.icon,
                title_fb_meta: head.data.title + " - " + head.data.motto,
                desc_fb_meta: head.data.meta_description,
                image_fb_meta: image_fb_meta,
                site_name_fb_meta: head.data.title,
                lat_fb_meta: head.location.latitude,
                lon_fb_meta: head.location.longitude,
                twitter_img_alt: head.data.title + " - " + head.data.motto + ". " + head.data.meta_description,
                googleSchemaContext: domain,
                googleSchemaTitle: head.data.title,
                googleSchemaStreetAddress: head.location.address,
                googleSchemaCity: head.location.city,
                googleSchemaCountry: head.location.country,
                googleSchemaZip: head.location.zip,
                googleSchemaPhone: head.location.phone,
                designColor: app.designColor,
                font: app.font,
                manager: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IndexSections, {
                    isDesktop: isDesktop,
                    html_sections: html_sections.hasOwnProperty("app_sections") ? html_sections.app_sections != null && html_sections.app_sections.length > 0 ? html_sections.app_sections : null : null,
                    app_data: app_data,
                    head: head,
                    app: app,
                    builder: builder,
                    navigation: navigation,
                    content: content,
                    propertyContent: props.propertyContent,
                    propertyAllImages: props.propertyAllImages,
                    propertyFeatures: props.propertyFeatures,
                    locations: locations,
                    footer: footer,
                    distincts: distincts,
                    profile: profile,
                    destinations: destinations,
                    collections: collections,
                    isHomepage: true,
                    categoriesContentDefault: props.categoriesContentDefault,
                    categoriesContentPromoted: props.categoriesContentPromoted,
                    categoriesContentPromoted2: props.categoriesContentPromoted2,
                    experienceCategoriesContentDefault: props.experienceCategoriesContentDefault,
                    experienceCategoriesContentPromoted: props.experienceCategoriesContentPromoted,
                    experienceCategoriesContentPromoted2: props.experienceCategoriesContentPromoted2
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Addons, {
                script_sections: script_sections.hasOwnProperty("app_sections") ? script_sections.app_sections != null && script_sections.app_sections.length > 0 ? script_sections.app_sections : null : null
            })
        ]
    }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5693,4285,8340,8201,9007,5553,8412,289,9440,8805,6638,9774,2888,179], function() { return __webpack_exec__(54493); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);